import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/menu';

interface CategoryFilterProps {
  activeCategory: string;
  onCategoryChange: (category: string) => void;
}

export default function CategoryFilter({ activeCategory, onCategoryChange }: CategoryFilterProps) {
  const { t } = useTranslation();

  return (
    <div className="relative w-full">
      {/* Right-edge fade to indicate scrollability */}
      <div className="absolute right-0 top-0 bottom-2 w-8 bg-gradient-to-l from-background-50 to-transparent pointer-events-none z-10 md:hidden" />
      <div
        className="flex gap-2 md:gap-3 overflow-x-auto pb-2 -mx-1 px-1 scrollbar-hide"
        style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
      >
        {categories.map((cat) => {
          const isActive = activeCategory === cat.id;
          return (
            <button
              key={cat.id}
              onClick={() => onCategoryChange(cat.id)}
              className={`
                flex-shrink-0
                h-9 sm:h-10 md:h-14 lg:h-16
                px-2.5 sm:px-3 md:px-4 lg:px-5
                rounded-lg md:rounded-xl
                flex items-center gap-1.5 sm:gap-2 md:gap-2.5
                text-xs sm:text-sm md:text-base
                font-medium
                transition-all duration-200 cursor-pointer
                border
                whitespace-nowrap
                btn-press
                ${
                  isActive
                    ? 'bg-primary-500 text-background-50 border-primary-500 shadow-sm shadow-primary-500/20'
                    : 'bg-background-100 text-foreground-600 border-background-200 hover:bg-background-200 hover:border-background-300 hover:text-foreground-800'
                }
              `}
            >
              <span className="w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6 flex items-center justify-center text-base sm:text-lg md:text-xl transition-transform duration-200 group-hover:scale-110">
                <i className={cat.icon} />
              </span>
              <span>{t(cat.nameKey)}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}